/**
 * ListViewSchema for Stock Entry DocType
 * 
 * Schema-driven configuration for Stock Entry list page.
 * 
 * This schema replaces hardcoded column definitions and default filters.
 * All list layout changes should be made in this file.
 */

import type { ListViewSchema } from "./types";

export const stockEntryListViewSchema: ListViewSchema = {
  doctype: "Stock Entry",
  views: {
    experience: {
      columns: [
        {
          fieldname: "name",
          label: "Stock Entry",
          width: 200,
          align: "left",
          type: "Link",
          sortable: true,
        },
        {
          fieldname: "posting_date",
          label: "Posting Date",
          width: 140,
          align: "left",
          type: "Date",
          sortable: true,
        },
        {
          fieldname: "stock_entry_type",
          label: "Type",
          width: 160,
          align: "left",
          type: "Link",
          sortable: true,
        },
        {
          fieldname: "from_warehouse",
          label: "From Warehouse",
          width: 160,
          align: "left",
          type: "Link",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "to_warehouse",
          label: "To Warehouse",
          width: 160,
          align: "left",
          type: "Link",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "docstatus",
          label: "Status",
          width: 120,
          align: "center",
          type: "Status",
          sortable: false,
        },
      ],
      defaultSort: {
        fieldname: "posting_date",
        direction: "desc",
      },
      defaultFilters: [],
      quickFilters: [
        {
          id: "all",
          label: "All",
          filters: [],
          default: true,
        },
        {
          id: "material_transfer",
          label: "Material Transfer",
          filters: [["stock_entry_type", "=", "Material Transfer"]],
        },
        {
          id: "material_receipt",
          label: "Material Receipt",
          filters: [["stock_entry_type", "=", "Material Receipt"]],
        },
      ],
      pageSizeOptions: [20, 50, 100, 200, 400, 500],
    },
  },
};

